// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.game-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
}
.crossword-editor-container {
  display: flex;
  flex: 1 1;
  margin: 10px;
}

.crossword-container {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  align-items: center;
}

.crossword-row {
  display: flex;
}

.crossword-row.empty {
  display: none;
}

.crossword-grid-number-header {
  padding: 0px;
  margin: 0px;
}


.crossword-grid .cell {
  border: 1px solid #000; /* Interactive cells will have a visible border */
  padding: 0px;
  margin: 0px;
  flex: 1 1;
  justify-content: center;
  align-items: center;
  width: 10vw;
  max-width: 6vw;
  height: 6vw; /* EnsuresT square aspect ratio */
}

.crossword-grid .cell.empty-rows-1 {
  max-width: 7vw;
  height: 7vw; /* EnsuresT square aspect ratio */
}

.crossword-grid .cell.empty-rows-2 {
  max-width: 7.5vw;
  height: 7.5vw; /* EnsuresT square aspect ratio */
}

@media (min-width: 660px) {
  .crossword-grid .cell {
    max-width: 40px;
    max-height: 40px;
  }
  .crossword-grid .cell.empty-rows-1 {
    max-width: 40px;
    height: 7vw; /* EnsuresT square aspect ratio */
  }
  
  .crossword-grid .cell.empty-rows-2 {
    max-width: 40px;
    height: 40px; /* EnsuresT square aspect ratio */
  }
}

.crossword-grid .cell .cell-content {
  position: relative;
  width: 100%;
  height: 100%;
  font-size: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.crossword-grid .cell.selected-word {
  background-color: rgba(130, 141, 238, 0.199);
}
.crossword-grid .cell.selected-letter {
  background-color: rgba(130, 141, 238, 0.726);
}

.crossword-grid .cell .clue-number {
  position: absolute;
  top: 2px;
  left: 2px;
  font-size: 10px;
  color: #000;
}

.crossword-grid .cell.cellBelow {
  border-bottom: none;
}

.crossword-grid .cell.cellAbove {
  margin-top: -1px;
}

.crossword-grid .cell.cellToRight {
  border-right: none;
}

.crossword-grid .cell.empty {
  border: 1px solid transparent;
  background-color: transparent; /* Make non-interactive cells transparent */
  margin-right: -1px;
  pointer-events: none;
}

.crossword-grid .cell.empty.cellToLeft {
  margin-left: -1px;
}

.check-button {
  margin-top: 20px;
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
}

.crossword-clue-section-container {
  background-color: rgba(247, 232, 186, 0.397);
  border-radius: 3px;
  border-radius: 3px;
  margin-bottom: 5px;
  width: 100%;
  padding: 10px;
  
}

.crossword-clues-container {
  display: flex;
  flex-direction: column;
  max-height: 140px;
  flex-wrap: wrap;
  max-width: 100%;
  padding: 10px;
  overflow-x: scroll;
}

.crossword-clue-container {
  display: flex;
  justify-content: flex-start;
  width: -moz-fit-content;
  width: fit-content;
  font-size: 60%;
  background-color: whitesmoke;
  border: 1px;
  border-color: rgba(202, 192, 174, 0.747);
  border-style: solid;
  padding: 1%;
  inline-size: 47%;
  text-align: left;
  margin: 1px;
}

@media (min-width: 500px) {
  .crossword-clue-container {
    max-width: 30%;
  }
}

@media (min-width: 800px) {
  .crossword-clues-container {
    max-height: 200px;
  }
  .crossword-clue-container {
    font-size: 100%;
  }
}

@media (min-width: 400px) {
  .crossword-clues-container {
    font-size: 55%;
  }
  .crossword-clue-container {
    max-width: 20%;
  }
}

@media (min-width: 300px) {
  .crossword-clues-container {
    font-size: 55%;
  }
  .crossword-clue-container {
    max-width: 30%;
  }
}

@media (max-width: 400px) {
  .crossword-clues-container {
    max-height: 125px;
  }
  .crossword-clue-container {
    font-size: 100%;
  }
}

.cell-content input {
  margin: 0px;
  padding: 0px;
}

.crossword-clues-container-header {
  display: flex;
  align-items: center;
  margin: 5px;
  padding-left: 15px;
  gap: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Games/Crossword/PublicCrossword/PublicCrossword.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,aAAa;EACb,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;;AAGA;EACE,sBAAsB,EAAE,iDAAiD;EACzE,YAAY;EACZ,WAAW;EACX,SAAO;EACP,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,WAAW,EAAE,iCAAiC;AAChD;;AAEA;EACE,cAAc;EACd,WAAW,EAAE,iCAAiC;AAChD;;AAEA;EACE,gBAAgB;EAChB,aAAa,EAAE,iCAAiC;AAClD;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,WAAW,EAAE,iCAAiC;EAChD;;EAEA;IACE,eAAe;IACf,YAAY,EAAE,iCAAiC;EACjD;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,4CAA4C;AAC9C;AACA;EACE,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B,EAAE,2CAA2C;EAC1E,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,4CAA4C;EAC5C,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,aAAa;;AAEf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,uBAAkB;EAAlB,kBAAkB;EAClB,cAAc;EACd,4BAA4B;EAC5B,WAAW;EACX,wCAAwC;EACxC,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,QAAQ;AACV","sourcesContent":[".game-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  height: 100%;\n}\n.crossword-editor-container {\n  display: flex;\n  flex: 1;\n  margin: 10px;\n}\n\n.crossword-container {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  align-items: center;\n}\n\n.crossword-row {\n  display: flex;\n}\n\n.crossword-row.empty {\n  display: none;\n}\n\n.crossword-grid-number-header {\n  padding: 0px;\n  margin: 0px;\n}\n\n\n.crossword-grid .cell {\n  border: 1px solid #000; /* Interactive cells will have a visible border */\n  padding: 0px;\n  margin: 0px;\n  flex: 1;\n  justify-content: center;\n  align-items: center;\n  width: 10vw;\n  max-width: 6vw;\n  height: 6vw; /* EnsuresT square aspect ratio */\n}\n\n.crossword-grid .cell.empty-rows-1 {\n  max-width: 7vw;\n  height: 7vw; /* EnsuresT square aspect ratio */\n}\n\n.crossword-grid .cell.empty-rows-2 {\n  max-width: 7.5vw;\n  height: 7.5vw; /* EnsuresT square aspect ratio */\n}\n\n@media (min-width: 660px) {\n  .crossword-grid .cell {\n    max-width: 40px;\n    max-height: 40px;\n  }\n  .crossword-grid .cell.empty-rows-1 {\n    max-width: 40px;\n    height: 7vw; /* EnsuresT square aspect ratio */\n  }\n  \n  .crossword-grid .cell.empty-rows-2 {\n    max-width: 40px;\n    height: 40px; /* EnsuresT square aspect ratio */\n  }\n}\n\n.crossword-grid .cell .cell-content {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  font-size: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.crossword-grid .cell.selected-word {\n  background-color: rgba(130, 141, 238, 0.199);\n}\n.crossword-grid .cell.selected-letter {\n  background-color: rgba(130, 141, 238, 0.726);\n}\n\n.crossword-grid .cell .clue-number {\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  font-size: 10px;\n  color: #000;\n}\n\n.crossword-grid .cell.cellBelow {\n  border-bottom: none;\n}\n\n.crossword-grid .cell.cellAbove {\n  margin-top: -1px;\n}\n\n.crossword-grid .cell.cellToRight {\n  border-right: none;\n}\n\n.crossword-grid .cell.empty {\n  border: 1px solid transparent;\n  background-color: transparent; /* Make non-interactive cells transparent */\n  margin-right: -1px;\n  pointer-events: none;\n}\n\n.crossword-grid .cell.empty.cellToLeft {\n  margin-left: -1px;\n}\n\n.check-button {\n  margin-top: 20px;\n  padding: 10px 20px;\n  font-size: 16px;\n  cursor: pointer;\n}\n\n.crossword-clue-section-container {\n  background-color: rgba(247, 232, 186, 0.397);\n  border-radius: 3px;\n  border-radius: 3px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding: 10px;\n  \n}\n\n.crossword-clues-container {\n  display: flex;\n  flex-direction: column;\n  max-height: 140px;\n  flex-wrap: wrap;\n  max-width: 100%;\n  padding: 10px;\n  overflow-x: scroll;\n}\n\n.crossword-clue-container {\n  display: flex;\n  justify-content: flex-start;\n  width: fit-content;\n  font-size: 60%;\n  background-color: whitesmoke;\n  border: 1px;\n  border-color: rgba(202, 192, 174, 0.747);\n  border-style: solid;\n  padding: 1%;\n  inline-size: 47%;\n  text-align: left;\n  margin: 1px;\n}\n\n@media (min-width: 500px) {\n  .crossword-clue-container {\n    max-width: 30%;\n  }\n}\n\n@media (min-width: 800px) {\n  .crossword-clues-container {\n    max-height: 200px;\n  }\n  .crossword-clue-container {\n    font-size: 100%;\n  }\n}\n\n@media (min-width: 400px) {\n  .crossword-clues-container {\n    font-size: 55%;\n  }\n  .crossword-clue-container {\n    max-width: 20%;\n  }\n}\n\n@media (min-width: 300px) {\n  .crossword-clues-container {\n    font-size: 55%;\n  }\n  .crossword-clue-container {\n    max-width: 30%;\n  }\n}\n\n@media (max-width: 400px) {\n  .crossword-clues-container {\n    max-height: 125px;\n  }\n  .crossword-clue-container {\n    font-size: 100%;\n  }\n}\n\n.cell-content input {\n  margin: 0px;\n  padding: 0px;\n}\n\n.crossword-clues-container-header {\n  display: flex;\n  align-items: center;\n  margin: 5px;\n  padding-left: 15px;\n  gap: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
